import WarehouseAdminOrderItemData, {
    IWarehouseAdminOrderItemData
} from "@/http/data/warehouse-admin-order-item-data";

export interface IWarehouseAdminOrderData {
    id: number;
    number: number|string|null;
    building: string;
    remark?: string|null;
    created?: string|null;
    created_by?: string|null;
    closed?: string|null;
    loaded?: string|null;
    delivered?: string|null;
    returned?: string|null;
    status: string;

    loaded_items?: number;
    delivered_items?: number;
    returned_items?: number;
    retoured_items?: number;

    delivery_driver_name?: string|null;
    delivery_driver_confirmed?: string|null;
    delivery_driver_confirmed_by?: string|null;

    delivery_recipient_name?: string|null;
    delivery_recipient_confirmed?: string|null;
    delivery_recipient_confirmed_by?: string|null;

    items?: IWarehouseAdminOrderItemData[];
}

export default class WarehouseAdminOrderData {
    public id: number;
    public number: number|string|null;
    public building: string;
    public remark: string|null;
    public created: string|null;
    public created_by: string|null;
    public closed: string|null;
    public loaded: string|null;
    public delivered: string|null;
    public returned: string|null;
    public status: string;

    public loaded_items: number;
    public delivered_items: number;
    public returned_items: number;
    public retoured_items: number;

    public delivery_driver_name: string|null;
    public delivery_driver_confirmed: string|null;
    public delivery_driver_confirmed_by: string|null;

    public delivery_recipient_name: string|null;
    public delivery_recipient_confirmed: string|null;
    public delivery_recipient_confirmed_by: string|null;

    public items: WarehouseAdminOrderItemData[];

    constructor(data: IWarehouseAdminOrderData) {
        this.id = Number(data.id);
        this.number = data.number ?? null;
        this.building = data.building;
        this.remark = data.remark ?? null;
        this.created = data.created ?? null;
        this.created_by = data.created_by ?? null;
        this.closed = data.closed ?? null;
        this.loaded = data.loaded ?? null;
        this.delivered = data.delivered ?? null;
        this.returned = data.returned ?? null;
        this.status = data.status;

        this.loaded_items = Number(data.loaded_items ?? 0);
        this.delivered_items = Number(data.delivered_items ?? 0);
        this.returned_items = Number(data.returned_items ?? 0);
        this.retoured_items = Number(data.retoured_items ?? 0);

        this.delivery_driver_name = data.delivery_driver_name ?? null;
        this.delivery_driver_confirmed = data.delivery_driver_confirmed ?? null;
        this.delivery_driver_confirmed_by = data.delivery_driver_confirmed_by ?? null;

        this.delivery_recipient_name = data.delivery_recipient_name ?? null;
        this.delivery_recipient_confirmed = data.delivery_recipient_confirmed ?? null;
        this.delivery_recipient_confirmed_by = data.delivery_recipient_confirmed_by ?? null;

        this.items = (data.items ?? []).map(
            item => new WarehouseAdminOrderItemData(item)
        );
    }
}